<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex  mu-gap-04">
            <section class="mu-d-flex ">

                <h1 class="mu-mb-00">Process details</h1>

                <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>


            </section>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>
                    <a class="table-link" @click="redirectToList()">Processes</a>
                </li>
                <li aria-current="page">Create new</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>

        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>

        </div>
        <div class="mcc-card">
                          
                            <div class="mcc-card__body">
        <form @submit.prevent="copyMutlipleProcesses()" v-show="fetchCall" id="formId" novalidate>

            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
               
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div class="mfc-slim-select-wrapper mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label for="application" class="mfc-label--required">Application</label>
                                            <select @change="selectedApp = $event.target.value" ref="appdropdownRef" name="applicationId" id="applicationId" required block label="Application">
                                                <option data-placeholder="true" value="" :selected="selectedApp ==''"></option>
                                                <option v-for="(app,key) in applications" :selected="selectedApp == app.id" :key="key" :value="app.id">{{app.name}}</option>
                                            </select>
                                        </div>
                                        <div class="mfc-input-wrapper  mfc-form-input-wrapper--width mu-d-block  mfc-form-input-container" v-for="(item, index) in applicationProcess.processes" :key="index">
                                            <label for="mds-processname" class="mfc-label--required">Process name</label>
                                            <input type="text" maxlength="50"  ref="processName" :name="getProcFieldName(index)" :id="getProcFieldName(index)" :pattern="nameRegex" :value="item.name" @change="updateProcessName($event,index)">
                                            <div class="mfc-help-text"></div>

                                        </div>
                                        <div class="mu-d-flex mu-justify-content-end ">
                                            <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                                <router-link :to="CONTEXT_PATH + '/design/applications/appprocesses'">
                                                    <button class="mcc-button mcc-button--outline mu-mr-05" title="Cancel" id="cancelBtn" type="button">
                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                </router-link>
                                                <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit" >
                                                    <mcc-icon name="save" aria-hidden="true"> </mcc-icon>  <span class="mcc-button__label">Save</span>
                                                </button>

                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                  
            </div>
        </form>
        </div>
        </div>
    </div>
</div>
</template>

<style scoped>

</style>

<script>
import ApplicationProcessAPI from "../../../services/ApplicationProcessAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "MultipleProcessCopy",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["design.processes.copy"],
            nameRegex: constantMessages.PATTERNS["name"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            applicationProcess: [],
            applications: [],
            fetchCall: false,
            updateCall: true,
            selectedApp: "",
            selectInstanceEntities: ""
        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        var self = this;
        if (this.$route.params.otherProps != undefined) {
            let selectedProcesses = this.$route.params.otherProps.processIds;
            this.selectedApp = this.$route.params.otherProps.appToCopyId;
            if (selectedProcesses != null && selectedProcesses.length > 0) {
                ApplicationProcessAPI.getMultipleProcessCopyInfo(selectedProcesses).then(result => {
                        self.applicationProcess = result.applicationProcess;
                        self.applications = result.applications;
                    })
                    .finally(() => {
                        self.fetchCall = true;
                    });
            } else {
                this.$router.push(
                    this.CONTEXT_PATH + '/design/applications/appprocesses'
                );
            }
        } else {
            self.fetchCall = true;
            this.$router.push(
                this.CONTEXT_PATH + '/design/applications/appprocesses'
            );
        }

        this.selectInstanceEntities = new SlimSelect({
            select: '#applicationId',

        })
    },
    methods: {
        
        copyMutlipleProcesses() {

            let form = $('#formId')
            let self = this;
          
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            self.applicationProcess.applicationId = self.selectedApp;
            self.updateCall = false;
            ApplicationProcessAPI.copyMutlipleProcesses(
                    self.applicationProcess
                )
                .then(response => {
                    self.updateCall = true;
                    if (response != undefined) {
                        if (response.error) {
                            if (response.message && response.message == "message.process.copy.failure") {
                                EventBus.$emit("error-notification", {
                                    msg: constantMessages.MESSAGES[response.message]
                                });
                            } else {
                                for (var k in response.messages) {
                                    let index = k.slice(-1);
                                    if (k.indexOf("duplicateprocess") != -1) {
                                        displayErrorMessage($(self.$refs.processName[index]), constantMessages.MESSAGES["error.process.duplicate.add"])
                                        self.$refs.processName[index].classList.add("ms-is-invalid")
                                    } else if (k.indexOf("duplicatename") != -1) {
                                        displayErrorMessage($(self.$refs.processName[index]), constantMessages.MESSAGES["error.process.duplicatename.add"])
                                        self.$refs.processName[index].classList.add("ms-is-invalid")

                                    } else if (k.indexOf("owaspName") != -1) {
                                        displayErrorMessage($(self.$refs.processName[index]), constantMessages.MESSAGES["error.input.owasp.error"])
                                        self.$refs.processName[index].classList.add("ms-is-invalid")

                                    }
                                }
                            }
                        } else {
                            self.$router.push(self.CONTEXT_PATH +
                                "/design/applications/" + self.selectedApp);

                            EventBus.$emit("success-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                })
                .finally(() => {});
        },
        updateProcessName(event, fieldIndex) {
            var field = this.$refs.processName[fieldIndex];
            if (event.target.value == "") {
                displayErrorMessage($(field), constantMessages.MESSAGES["error.processname.required"])
                field.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(field), constantMessages.MESSAGES["error.processname.50"])
                field.classList.add("ms-is-invalid")
            } else{
                field.classList.remove("ms-is-invalid") 
            }

            this.applicationProcess.processes[fieldIndex].name = event.target.value;
        },
        getProcFieldName(index) {
            return "appProcesses" + index + "name";
        },
        redirectToList() {
            localStorage.setItem("ProcessList", "ProcessList");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications/appprocesses'
            );
        }
    },
}
</script>
<style scoped>
</style>
